:host {
  ux-modal-content {
    width: unset;
  }

  @media only screen and (min-width: $desktop-s) {
    .ux-modal__outer {
      max-width: 1470px;
      width: 83.3333%;
    }
  }
}

.container {
  padding: 20px 0 20px;

  @media only screen and (min-width: $tablet) {
    padding: 10px 30px 20px;
  }

  @media only screen and (min-width: $desktop-s) {
    padding: 10px 70px 30px;
  }
}

ux-progress-bar,
.content-container {
  margin-bottom: 30px;

  @media only screen and (min-width: $tablet) {
    margin-bottom: 40px;
  }

  @media only screen and (min-width: $desktop-s) {
    margin-bottom: 60px;
  }
}

.navigation {
  display: flex;
  flex-direction: column;

  ux-button:first-of-type {
    margin-bottom: 15px;
  }

  @media only screen and (min-width: $tablet) {
    flex-direction: row;
    justify-content: space-between;

    ux-button:first-of-type {
      margin-bottom: 0;
    }
  }
}

.step-content {
  display: none;
}

.step-content.visible {
  display: block;
}

.step-content.hidden {
  display: none;
}
